__turbopack_context__.v({
  "column": "Scroller-module-scss-module__UoRRFq__column",
  "container": "Scroller-module-scss-module__UoRRFq__container",
  "row": "Scroller-module-scss-module__UoRRFq__row",
  "scrollButton": "Scroller-module-scss-module__UoRRFq__scrollButton",
  "scrollButtonNext": "Scroller-module-scss-module__UoRRFq__scrollButtonNext",
  "scrollButtonPrev": "Scroller-module-scss-module__UoRRFq__scrollButtonPrev",
  "scroller": "Scroller-module-scss-module__UoRRFq__scroller",
});
